import React from 'react';
import classNames from 'classnames';

import css from './PopupOpenerButton.module.css';

const FilterIcon = ({ className }) => (
  <svg 
    className={className}
    width="16" 
    height="16" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M3 6h18M7 12h10M10 18h4" 
      stroke="currentColor" 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * PopupOpenerButton component
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.isSelected] - Whether the filter is selected
 * @param {number} [props.labelMaxWidth] - The maximum width of the label
 * @param {Function} props.toggleOpen - The function to toggle the filter
 * @param {React.Node} props.children - The children
 * @returns {JSX.Element}
 */
const PopupOpenerButton = props => {
  const { isSelected = false, labelMaxWidth = null, toggleOpen, children } = props;

  const labelStyles = isSelected ? css.labelSelected : css.label;
  const labelMaxWidthMaybe = labelMaxWidth ? { maxWidth: `${labelMaxWidth}px` } : {};
  const labelMaxWidthStyles = labelMaxWidth ? css.labelEllipsis : null;

  return (
    <button
      className={classNames(labelStyles, labelMaxWidthStyles)}
      style={labelMaxWidthMaybe}
      onClick={() => toggleOpen()}
    >
      <FilterIcon className={css.filterIcon} />
      {children}
    </button>
  );
};

export default PopupOpenerButton;
